import { useSession } from "../../context/SessionContext";
import AccesoDirecto from "../molecules/dashboard/AccesoDirecto";
import { GrAnnounce } from "react-icons/gr";
import { MdOutlineNewspaper } from "react-icons/md";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const AvisosYBlogTemplate = () => {
    const { user } = useSession();

    const linksRH = [
        { label: "Avisos", path: "/avisos", icon: GrAnnounce },
    ];

    return (
        <div className="space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Avisos", to: null },
                    ]}
                />
            </CardHeader>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {user?.role !== "Client" ?
                (linksRH?.map((link, index)=>
                    <AccesoDirecto href={link.path} label={link.label} icon={link?.icon} key={index} />
                )) : (
                    <>
                        <AccesoDirecto href="/avisos" label="Avisos" icon={GrAnnounce}/>
                        <a
                            href="http://ramirezSoto.com.mx/blog"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="
                                w-full h-48 flex flex-col items-center justify-center p-4 text-center
                                bg-rs-azul rounded-lg hover:bg-rs-rojo shadow-md
                                transition transform hover:scale-105
                                shadow-black hover:shadow-xl hover:shadow-rs-rojo
                            "
                        >
                            <MdOutlineNewspaper className="text-white text-4xl"  size={50}/>
                            <span className="text-white font-bold text-2xl">Blog</span>
                        </a>
                    </>
                )}
            </div>
        </div>
    );
};

export default AvisosYBlogTemplate;